import type {
    IChartCommonConfigHelper,
    IChartConfigHelper,
} from '@src/slide/content-viewer/service/canvas-renderer/core/canvas-render/components/chart-component/interface/chart-config.interface';
import type { ICommonConfig } from '@tencent/chart/lib/chart-ui/interface';
import type { ChartContext } from '@src/slide/domain/ui-model/element-modeles/chart-models/context';
import { ChartLayoutInfo } from '../../interface/chart-component.interface';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { generateCustomStyles, getShapeAttr } from '../../utils/style';

export class PlotAreaConfigHelper implements IChartCommonConfigHelper {
    private readonly chartHelper: IChartConfigHelper;
    private readonly chartModel: IChartModel;
    private readonly chartLayout: ChartLayoutInfo;

    /**
     *
     * @param chartHelper chart配置处理类
     * @param context
     */
    public constructor(chartHelper: IChartConfigHelper, private context: ChartContext) {
        this.chartHelper = chartHelper;
        this.chartModel = context.getChartModel();
    }

    public getCommonConfig(): ICommonConfig {
        return { plotArea: this.generatePlotAreaConfig() };
    }

    private generatePlotAreaConfig() {
        const { plotArea } = this.chartModel;
        const shapeAttrs = getShapeAttr(plotArea.props);
        const { fill, border } = shapeAttrs;
        return {
            style: {
                fill,
                fillOpacity: 1,
                lineWidth: border?.lineWidth,
                lineDash: border?.lineDash,
                stroke: border?.stroke,
                lineJoin: border?.lineJoin,
                lineCap: border?.lineCap,
                customStyles: generateCustomStyles(shapeAttrs),
            },
        };
    }
}
